import { render, staticRenderFns } from "./workerNotice.vue?vue&type=template&id=bc5f993a&scoped=true"
import script from "./workerNotice.vue?vue&type=script&lang=js"
export * from "./workerNotice.vue?vue&type=script&lang=js"
import style0 from "./workerNotice.vue?vue&type=style&index=0&id=bc5f993a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5f993a",
  null
  
)

export default component.exports